import React, { useState } from 'react'
import { signInFailure, signInStart, signInSuccess } from '../redux/user/userSlice'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react/dist/iconify.js'
import * as AWS from "aws-sdk";
import * as AWSCognito from "amazon-cognito-identity-js";
import AWSConfig from "../helper/AWSConfig";

const StucredLoginLayer = () => {
    const [formData, setFormData] = useState({})
    const [confirmpassword, setconfirmPassword] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    // ✅ OTP states
    const [showOtpModal, setShowOtpModal] = useState(false)
    const [otp, setOtp] = useState("")
    const [pendingNavigationData, setPendingNavigationData] = useState(null)

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value.trim() });
    };

    const { loading, error: errorMessage } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        let poolData = {
            UserPoolId: AWSConfig.UserPoolId,
            ClientId: AWSConfig.ClientId
        };
        
        e.preventDefault();

        if (!formData.email) {
            return dispatch(signInFailure('Please fill all the fields'));
        }

        try {
            dispatch(signInStart());
            let userPool = new AWSCognito.CognitoUserPool(poolData);

            // 🔹 YOUR EXISTING LOGIN API CALL
            let res;
            // Replace this line with actual login API call
            res = await fetch("/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            let data = await res.json();
            let token = data.token;
            data = data.rest;

            if(data.newUser === false){
                setconfirmPassword(true)
                setShowPassword(true)
            } else {
                setShowPassword(true)
            }

            if(data.success === false){
                return dispatch(signInFailure(data.message));
            }

            if(res.ok){
                if(data.newUser === true && token !== undefined){
                    localStorage.setItem('access_token', token)
                }

                dispatch(signInSuccess(data));

                // ✅ Store data for OTP modal and stop navigation
                setPendingNavigationData({ data, token });
                setShowOtpModal(true);
                return; // ⛔ Prevent immediate navigation
            }

        } catch (error) {
            dispatch(signInFailure(error.message));
        }
    };

    // ✅ OTP verification function
    const verifyOtp = async () => {
        try {
            const { token, data } = pendingNavigationData;

            const res = await fetch("/verify_otp", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ otp })
            });

            const result = await res.json();

            if(!result.status){
                return dispatch(signInFailure(result.message || "OTP verification failed"));
            }

            // ✅ OTP success → close modal and navigate
            setShowOtpModal(false);

            // 🔹 Original navigation logic
            if(data.newUser === false){
                navigate('/');
                return;
            }

            if(data.role === 'admin' && data.newUser === true && showPassword && formData.password !== undefined ){
                navigate('/overall');
            } else if(data.role === 'Agencies' && data.newUser === true && formData.password !== undefined ){
                navigate('/agencies/dashboard');
            } else if(data.role === "Agent" && data.newUser === true && (formData.password !== undefined || formData.password !== null)){
                navigate("/stucred_dashboard");
            } else {
                navigate("/");
            }

        } catch (error) {
            dispatch(signInFailure("OTP verification failed"));
        }
    };

    // ✅ Inline modal styles
    const modalOverlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999
    };

    const modalBoxStyle = {
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "8px",
        width: "350px",
        textAlign: "center"
    };

    return (
        <section className="auth bg-base d-flex flex-wrap">
            <div className="auth-left d-lg-block d-none">
                <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                    <img src="assets/images/login.jpg" alt="" />
                </div>
            </div>
            <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                <div className="max-w-464-px mx-auto w-100">
                    <div>
                        <Link to="/" className="mb-40 max-w-290-px"></Link>
                        <h4 className="mb-12">Sign In to your Stucred SBA</h4>
                        <p className="mb-32 text-secondary-light text-lg">
                            Welcome back! please enter your detail
                        </p>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="icon-field mb-16">
                            <span className="icon top-50 translate-middle-y">
                                <Icon icon="mage:email" />
                            </span>
                            <input
                                type="email"
                                className="form-control h-56-px bg-neutral-50 radius-12"
                                placeholder="Email"
                                name='email'
                                id='email'
                                onChange={handleChange}
                            />
                        </div>
                        <div className="icon-field mb-16">
                            <input
                                type="password"
                                className="form-control h-56-px bg-neutral-50 radius-12"
                                placeholder="Password"
                                name='password'
                                id='password'
                                onChange={handleChange}
                            />
                        </div>
                        <div className="d-flex justify-content-between gap-2 mb-16">
                            <div className="form-check style-check d-flex align-items-center">
                                <input
                                    className="form-check-input border border-neutral-300"
                                    type="checkbox"
                                    id="remeber"
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor="remeber">
                                    Remember me
                                </label>
                            </div>
                            <Link to="/forgot-password" className="text-primary-600 fw-medium">
                                Forgot Password?
                            </Link>
                        </div>
                        <button type="submit" className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32">
                            Sign In
                        </button>
                        <div className="mt-32 center-border-horizontal text-center">
                            <span className="bg-base z-1 px-4">Or sign in with</span>
                        </div>
                        <div className="text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32">
                            <Link to='/' className="fw-semibold text-primary-light py-16 px-12 w-100 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50">
                                <img
                                    src="assets/images/stpng.png"
                                    alt="image_user"
                                    className="w-40-px h-40-px object-fit-cover rounded-circle"
                                />
                                Collection
                            </Link>
                        </div>
                    </form>
                </div>
            </div>

            {/* ✅ OTP Modal */}
            {showOtpModal && (
                <div style={modalOverlayStyle}>
                    <div style={modalBoxStyle}>
                        <h5>Enter OTP</h5>
                        <input
                            type="text"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            placeholder="Enter 4-digit OTP"
                            className="form-control mb-3"
                        />
                        <button className="btn btn-success w-100" onClick={verifyOtp}>
                            Verify OTP
                        </button>
                    </div>
                </div>
            )}
        </section>
    )
}

export default StucredLoginLayer
